function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { Path } from "./Path";
import { Vector2d } from "@stage/math";
import { parse as parseNumber } from "./svg/numbers";
import { ArcCurve, CubicBezierCurve, LineCurve } from "./curve";
import { PathCurve } from "./PathCurve";
import { Curves } from "./curve/util";

/**
 * 弧度
 * @param rs 弧度开始
 * @param re 弧度结束
 * @param radian 弧度
 * @param radius 半径
 */
function cubicBezier(s, c, e, radius) {
  var v1 = Vector2d.sub(c, s);
  var v2 = Vector2d.sub(e, c);
  //圆弧-开始 & 结束
  var rs = Vector2d.sub(c, Vector2d.multiplyScalar(Vector2d.normalize(v1), radius));
  var re = Vector2d.add(c, Vector2d.multiplyScalar(Vector2d.normalize(v2), radius));
  //圆弧-弧度计算? 可靠？ 还是应该结合r调整？
  var radian = Math.acos(Vector2d.dot(Vector2d.multiplyScalar(v1, -1), v2) / (Vector2d.lengthOf(v1) * Vector2d.lengthOf(v2)));
  var h = 4 / 3 * (1 - Math.cos(radian / 2)) / Math.sin(radian / 2);
  var c1 = Vector2d.add(rs, Vector2d.multiplyScalar(Vector2d.normalize(v1), h * radius));
  var c2 = Vector2d.sub(re, Vector2d.multiplyScalar(Vector2d.normalize(v2), h * radius));
  return new CubicBezierCurve(c1, c2, re);
}
export var Paths;
(function (_Paths) {
  function parse(define) {
    var path = new Path();
    var c = new Vector2d();
    // let prevCtrl: IVector2d = new Vector2d();

    var pathCurve = null;
    var commands = define.match(/[a-df-z][^a-df-z]*/ig);
    var _loop = function _loop() {
      var command = commands[i];
      var type = command.charAt(0);
      var argValue = command.slice(1).trim();
      //是否小写
      // let offset: number = 0;
      var args;
      var relativeFlag = false;
      if (type === type.toLowerCase()) {
        relativeFlag = true;
      }
      switch (type) {
        case 'a':
        case 'A':
          {
            args = parseNumber(argValue, [3, 4], 7);
            break;
          }
        default:
          {
            args = parseNumber(argValue);
          }
      }
      var offset = 0;
      function relative(x, y) {
        return {
          x: c.x + x,
          y: c.y + y
        };
      }
      function nextVec2() {
        var vec = {
          x: args[offset],
          y: args[offset + 1]
        };
        if (relativeFlag) {
          vec = relative(vec.x, vec.y);
        }
        offset += 2;
        return vec;
      }
      function next() {
        return args[offset++];
      }
      function nextAndMoveTo() {
        c = nextVec2();
        return c;
      }

      /**
       * 获取平滑控制点
       * 控制点是上一条曲线命令的控制点在当前位置上的反射点；
       * 若上一条命令不是曲线命令，则其与曲线的起始点（当前位置）相同
       */
      function smoothCtrl() {
        var lastCtrl = c;
        var curve = pathCurve.curves[pathCurve.curves.length - 1];
        if (curve) {
          switch (curve.type) {
            case "QuadraticBezierCurve":
              lastCtrl = curve.c;
              break;
            case "CubicBezierCurve":
              lastCtrl = curve.ce;
              break;
          }
        }
        return {
          x: c.x - (lastCtrl.x - c.x),
          y: c.y - (lastCtrl.y - c.y)
        };
      }
      switch (type) {
        case 'm':
        case 'M':
          {
            pathCurve = new PathCurve(nextAndMoveTo());
            path.push(pathCurve);
            while (offset < args.length) {
              pathCurve.lineTo(nextAndMoveTo());
            }
            break;
          }
        case 'h':
          {
            while (offset < args.length) {
              c = {
                x: c.x + next(),
                y: c.y
              };
              pathCurve.lineTo(c);
            }
            break;
          }
        case 'H':
          {
            while (offset < args.length) {
              c = {
                x: next(),
                y: c.y
              };
              pathCurve.lineTo(c);
            }
            break;
          }
        case 'v':
          {
            while (offset < args.length) {
              c = {
                x: c.x,
                y: c.y + next()
              };
              pathCurve.lineTo(c);
            }
            break;
          }
        case 'V':
          {
            while (offset < args.length) {
              c = {
                x: c.x,
                y: next()
              };
              pathCurve.lineTo(c);
            }
            break;
          }
        case 'l':
        case 'L':
          {
            while (offset < args.length) {
              pathCurve.lineTo(nextAndMoveTo());
            }
            break;
          }
        case 'c':
        case 'C':
          {
            while (offset < args.length) {
              pathCurve.cubicBezierTo(nextVec2(), nextVec2(), nextAndMoveTo());
            }
            break;
          }
        case 's':
        case 'S':
          {
            /**
             * https://developer.mozilla.org/zh-CN/docs/Web/SVG/Attribute/d#%E4%B8%89%E6%AC%A1%E8%B4%9D%E5%A1%9E%E5%B0%94%E6%9B%B2%E7%BA%BF
             */
            while (offset < args.length) {
              //若上一条命令不是曲线命令，则其与曲线的起始点（当前位置）相同
              pathCurve.cubicBezierTo(smoothCtrl(), nextVec2(), nextAndMoveTo());
            }
            break;
          }
        case 'q':
        case 'Q':
          {
            while (offset < args.length) {
              pathCurve.quadraticBezierTo(nextVec2(), nextAndMoveTo());
            }
            break;
          }
        case 't':
        case 'T':
          {
            while (offset < args.length) {
              pathCurve.quadraticBezierTo(smoothCtrl(), nextAndMoveTo());
            }
            break;
          }
        case 'a':
        case 'A':
          {
            while (offset < args.length) {
              pathCurve.arcTo(next(), next(), next(), next() === 1, next() === 1, nextAndMoveTo());
            }
            break;
          }
        case 'z':
        case 'Z':
          {
            pathCurve.closepath();
            c = pathCurve.begin;
            //准备新的路径
          }
      }
    };
    for (var i = 0; i < commands.length; i++) {
      _loop();
    }
    return path;
  }
  _Paths.parse = parse;
  function stringfiy(path) {
    var commands = [];
    function op(name) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      commands.push("".concat(name, " ").concat(args.join(' ')));
    }
    var _iterator = _createForOfIteratorHelper(path.curves),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var pathCurve = _step.value;
        op("M", pathCurve.begin.x, pathCurve.begin.y);
        var _iterator2 = _createForOfIteratorHelper(pathCurve.curves),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var curve = _step2.value;
            switch (curve.type) {
              case "LineCurve":
                op('L', curve.to.x, curve.to.y);
                break;
              case "QuadraticBezierCurve":
                op('Q', curve.c.x, curve.c.y, curve.to.x, curve.to.y);
                break;
              case "CubicBezierCurve":
                op('C', curve.cs.x, curve.cs.y, curve.ce.x, curve.ce.y, curve.to.x, curve.to.y);
                break;
              case "ArcCurve":
                op("A", curve.rx, curve.ry, curve.axisRotation, curve.lrc ? 1 : 0, curve.sweep ? 1 : 0, curve.to.x, curve.to.y);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        if (pathCurve.close) {
          op("Z");
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return commands.join(' ');
  }
  _Paths.stringfiy = stringfiy;
  function rounding(path, round) {
    var roundPath = new Path();
    // const curve = new PathCurve({x: 64, y: 0});
    // curve.lineTo({x: 192, y: 0})
    // curve.cubicBezierTo({x: 209, y: 0}, {x: 225, y: 7}, {x: 23})
    var maxRound = path.curves.reduce(function (v, pathCurve) {
      var minLineCurveLength = Infinity;
      var begin = pathCurve.begin;
      var _loop2 = function _loop2() {
        var current = pathCurve.curves[i];
        var next = pathCurve.curves[i + 1];
        switch (current.type) {
          case "LineCurve":
            {
              function apply() {
                minLineCurveLength = Math.min(Vector2d.lengthOf(Vector2d.sub(current.to, begin)), minLineCurveLength);
              }
              if ((next === null || next === void 0 ? void 0 : next.type) === 'LineCurve') {
                apply();
              } else {
                var prev = pathCurve.curves[i - 1];
                if (i > 0 && prev.type === 'LineCurve') {
                  apply();
                }
              }
            }
        }
        begin = current.to;
      };
      for (var i = 0; i < pathCurve.curves.length; i++) {
        _loop2();
      }
      return Math.min(minLineCurveLength / 2, v);
    }, Infinity);
    round = Math.min(round, maxRound);
    if (round <= 0) {
      return path;
    }
    // n.push(curve);
    var _iterator3 = _createForOfIteratorHelper(path.curves),
      _step3;
    try {
      var _loop3 = function _loop3() {
        var pathCurve = _step3.value;
        var pathBegin = pathCurve.begin;
        var curves = pathCurve.curves;
        var roundCurves = [];
        function append() {
          roundCurves.push.apply(roundCurves, arguments);
        }
        var pBegin = pathCurve.begin;
        var begin = pathCurve.begin;

        /**
         *
         * @param s 开始线点
         * @param c 角点
         * @param e 结束线点
         */
        function appendRoundLineCurve(s, c, e) {
          var v1 = Vector2d.sub(c, s);
          var v2 = Vector2d.sub(e, c);
          var v1n = Vector2d.normalize(v1);
          var v2n = Vector2d.normalize(v2);
          //2个要转换圆角的向量-开始 & 结束
          var rs = Vector2d.sub(c, Vector2d.multiplyScalar(v1n, round));
          var re = Vector2d.add(c, Vector2d.multiplyScalar(v2n, round));
          var _Curves$fittingRoutin = Curves.fittingRoutingCubicBezier(v1n, v2n, round),
            cv1 = _Curves$fittingRoutin.cv1,
            cv2 = _Curves$fittingRoutin.cv2;
          var c1 = Vector2d.add(rs, cv1);
          var c2 = Vector2d.sub(re, cv2);
          append(new LineCurve(rs));
          append(new CubicBezierCurve(c1, c2, re));
          return re;
        }
        var first = curves[0];
        var close = pathCurve.close;
        curves.forEach(function (current, i) {
          switch (current.type) {
            case "LineCurve":
              {
                var nextCurve = pathCurve.curves[i + 1];
                var last = !nextCurve;
                if (last) {
                  //结束了
                  // append(current);
                  //闭合原点
                  if (current.to.x === pBegin.x && current.to.y === pBegin.y) {
                    pBegin = appendRoundLineCurve(begin, pBegin, first.to);
                  } else {
                    if (close) {
                      begin = appendRoundLineCurve(begin, current.to, pBegin);
                      //闭合与初始角度
                      if (first.type === 'LineCurve') {
                        pBegin = appendRoundLineCurve(current.to, pBegin, first.to);
                      }
                    } else {
                      append(current);
                      begin = current.to;
                    }
                  }
                  // roundLineCurve()
                  //结束了
                } else {
                  if (nextCurve.type === 'LineCurve') {
                    begin = appendRoundLineCurve(begin, current.to, nextCurve.to);
                  } else {
                    append(current);
                    begin = current.to;
                  }
                }
                break;
              }
            default:
              {
                append(current);
                begin = current.to;
              }
          }
        });
        roundPath.push(new PathCurve(pBegin, roundCurves));
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop3();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return roundPath;
  }
  _Paths.rounding = rounding;
  function expandGrid(path, grid, offset) {
    var offsetX = Math.max(offset.x, -grid.width);
    var offsetY = Math.max(offset.y, -grid.height);
    function expandValue(value, min, max, offset) {
      if (value < min) {
        return value;
      }
      if (value > max) {
        return value + offset;
      }
      var weight = (value - min) / (max - min);
      return Math.round((value + offset * weight) * 10) / 10;
    }
    function expand(vector) {
      return {
        x: expandValue(vector.x, grid.x, grid.x + grid.width, offsetX),
        y: expandValue(vector.y, grid.y, grid.y + grid.height, offsetY)
      };
    }
    function expandCurve(value, curve) {
      switch (curve.type) {
        case "LineCurve":
          {
            value.push(_objectSpread(_objectSpread({}, curve), {}, {
              to: expand(curve.to)
            }));
            break;
          }
        case "ArcCurve":
          {
            //ArcCurve要转为CubicBezierCurve 达到
            var to = expand(curve.to);
            value.push(new ArcCurve(curve.rx, curve.ry, curve.axisRotation, curve.lrc, curve.sweep, to));
            break;
          }
        case "CubicBezierCurve":
          {
            value.push(_objectSpread(_objectSpread({}, curve), {}, {
              cs: expand(curve.cs),
              ce: expand(curve.ce),
              to: expand(curve.to)
            }));
            break;
          }
        case "QuadraticBezierCurve":
          {
            value.push(_objectSpread(_objectSpread({}, curve), {}, {
              c: expand(curve.c),
              to: expand(curve.to)
            }));
            break;
          }
      }
    }
    var curves = path.curves.map(function (pathCurve) {
      var begin = pathCurve.begin;
      var curves = pathCurve.curves;
      var expandCurves = [];
      var item = new PathCurve(expand(begin), curves.reduce(function (value, curve) {
        expandCurve(value, curve);
        return value;
      }, expandCurves));
      if (pathCurve.close) {
        item.closepath();
      }
      return item;
    });
    return new Path(curves);
  }
  _Paths.expandGrid = expandGrid;
})(Paths || (Paths = {}));